// extracted by mini-css-extract-plugin
module.exports = {"label":"SimpleLabel_label__oPylY"};